import { useEffect, useRef, useState } from "react";
import IndoorPositioningEquipmentLive from "../../../../api/IndoorPositioningEquipmentLive";

// 2s poll of /live/equipment, copying useLiveData's shape (isActiveRef guard,
// clear-on-machineID-change). Records stay in METRES exactly as the backend
// sends them -- projection to pixels happens at render time in LiveCanvas, so
// a canvas resize (or, later, a zoom) never blanks this list nor restarts the
// poll. Unlike personnel we don't keep a sticky last-known-position cache
// here: the backend already encodes "no usable pose" as status === "offline",
// and EquipmentLayer never renders those, so there is nothing to paper over
// between polls.
export const useLiveEquipment = (machineID, open = true, isPaused) => {
  const [equipment, setEquipment] = useState([]);
  const [equipmentLoading, setEquipmentLoading] = useState(false);

  const isActiveRef = useRef(true);

  useEffect(() => {
    if (!open || !machineID || isPaused) return;

    isActiveRef.current = true;
    setEquipment([]);

    const fetchEquipment = async () => {
      if (!isActiveRef.current) return;

      try {
        const response =
          await IndoorPositioningEquipmentLive.GetEquipment(machineID);

        if (response.code === 200 && isActiveRef.current) {
          setEquipment(response.data?.equipment || []);
        }
      } catch (error) {
        // This is a production monitoring screen: the backend for this
        // endpoint may still be mid-rollout, so a failed/未部署 call must
        // never take the rest of the dashboard down with it.
        console.error("Failed to fetch equipment data:", error);
      } finally {
        if (isActiveRef.current) setEquipmentLoading(false);
      }
    };

    setEquipmentLoading(true);
    fetchEquipment();

    const interval = setInterval(fetchEquipment, 2000);

    return () => {
      isActiveRef.current = false;
      clearInterval(interval);
    };
  }, [open, machineID, isPaused]);

  return { equipment, equipmentLoading };
};
